import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { milTitle, milList0, shopInMil, milList1, milListAd },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="230181" type="struct" title="军事标题" groupName="军事" content={milTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="195854"
                    type="recommend"
                    title="军事列表1"
                    groupName="军事"
                    content={milList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="225745"
                    type="recommend"
                    title="军事区电商"
                    groupName="军事"
                    content={shopInMil}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="195862"
                    type="recommend"
                    title="军事列表2"
                    groupName="军事"
                    content={milList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={milListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
